// Import general mixin for shared functionality.
import defaultApp from './defaultApp.js';

// Import components for this specific app.
import ActivityItem from './components/ActivityItem.vue';

const activitiesApp = {
    ...defaultApp,
    // Overwrite default app functionalities as you please by using the spread operator.
    components: {
        ...defaultApp.components,
        ActivityItem,
    },
    data() {
        return {
            ...defaultApp.data(),
            showAllRadios: {},
        };
    },
    computed: {
        ...defaultApp.computed,
        radioFacets() {
            if (!this.facetsSet) return [];
            return this.data.facets.filter(facet => facet.inputType === this.constants.inputTypes.radio && facet.options.length);
        },
    },
    methods: {
        ...defaultApp.methods,
        // Method to set facets array.
        setFacets(response) {
            if (!response || response.status != 200 || !response.data.facets) return;
            this.data.facets = response.data.facets
                .sort((a, b) => a.sortOrder - b.sortOrder)
                .map(facet => ({
                    ...facet,
                    values: facet.options.filter(option => option.selected).map(option => option.valueAlias),
                }));
            this.data.queryCount = response.data.queryCount;
            this.radioFacets.forEach(facet => {
                if (this.showAllRadios[facet.alias]) return;
                this.showAllRadios[facet.alias] = false;
            });
        },
        getRadioFacetOptions(facetAlias) {
            const facet = this.data.facets.find(facet => facet.alias === facetAlias);
            if (!facet) return [];
            if (this.showAllRadios[facetAlias]) return facet.options;
            return facet.options.slice(0, this.constants.radio.maxOptions);
        },
    },
};

export default activitiesApp;
